import { endOfMonth, startOfMonth } from 'date-fns'
import { type Quote } from 'finviz-charts/server/offScreenCanvasRender'

import { getDate } from '../../../header/utils'
import { ChartBaseData } from './types'

/**
 * Only get data between from/to range
 */
export function filterDataForChart(quote: Quote, fromDate: number, toDate: number) {
  const monthlyData: ChartBaseData[] = []

  const fromTimestamp = getDate(startOfMonth(getDate(fromDate))).getTime()
  const toTimestamp = getDate(endOfMonth(getDate(toDate))).getTime()
  for (let index = 0; index < quote.date.length; index++) {
    const currentTimestamp = quote.date[index] * 1000
    const currentClose = quote.close[quote.barToDataIndex[index]]

    if (fromTimestamp > currentTimestamp || currentTimestamp > toTimestamp) continue

    monthlyData.push({ date: currentTimestamp, close: currentClose })
  }

  return monthlyData
}
